import { bindable } from 'aurelia-framework';

export class UtilizationFactor {
  @bindable
  utilizationFactor?: number;

  status = 'error';

  attached() {
    const factor = +this.utilizationFactor;
    if (Number.isNaN(factor)) {
      return;
    }

    if (factor <= 0) {
      this.status = 'error';
    } else if (factor < 81) {
      this.status = 'ok';
    } else if (factor < 96) {
      this.status = 'warning';
    } else if (factor >= 96) {
      this.status = 'error';
    } else {
      this.status = 'error';
    }
  }
}
